import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faHandshake, faChartLine, faUsers } from '@fortawesome/free-solid-svg-icons';
import './About.css';

function About() {
  return (
    <section id="about" className="about-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="about-content">
            <div className="section-header">
              <h2>Despre Noi</h2>
              <div className="underline"></div>
            </div>
            
            <div className="about-text">
              <p className="lead">
                Arges Expres Imobiliare reprezintă viziunea unei echipe cu experiență vastă în domeniul imobiliar, 
                aducând o abordare proaspătă și dinamică pe piața din Curtea de Argeș.
              </p>
              
              <p>
                Deși suntem o companie nou înființată, echipa noastră reunește profesioniști cu peste 10 ani de 
                experiență în tranzacții imobiliare, evaluări și consultanță în domeniu.
              </p>

              <p>
                Ne diferențiem prin atenția deosebită acordată fiecărui client și prin angajamentul nostru de a 
                oferi servicii la cele mai înalte standarde de profesionalism și etică.
              </p>
            </div>

            {/* <div className="stats-container">
              <div className="stat-item">
                <FontAwesomeIcon icon={faUsers} className="stat-icon" />
                <div className="stat-info">
                  <h4>500+</h4>
                  <p>Clienți Mulțumiți</p>
                </div>
              </div>
              <div className="stat-item">
                <FontAwesomeIcon icon={faHandshake} className="stat-icon" />
                <div className="stat-info">
                  <h4>300+</h4>
                  <p>Tranzacții Finalizate</p>
                </div>
              </div>
            </div> */}
          </Col>

          <Col lg={6} className="about-values">
            <div className="values-grid">
              <div className="value-card">
                <FontAwesomeIcon icon={faClock} className="value-icon" />
                <h3>Disponibilitate</h3>
                <p>Suntem mereu la dispoziția clienților noștri, oferind suport și consultanță ori de câte ori este nevoie.</p>
              </div>
              
              <div className="value-card">
                <FontAwesomeIcon icon={faHandshake} className="value-icon" />
                <h3>Profesionalism</h3>
                <p>Echipa noastră pune accent pe etică și profesionalism în fiecare aspect al activității.</p>
              </div>
              
              <div className="value-card">
                <FontAwesomeIcon icon={faChartLine} className="value-icon" />
                <h3>Expertiză</h3>
                <p>Cunoștințele acumulate în peste 10 ani de activitate ne permit să oferim cele mai bune soluții.</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;